import { render } from "./DropdownLink.vue?vue&type=template&id=5c761365"
const script = {}

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__